import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksSubmitButton from '../../../../components/books/common/buttons/BooksSubmitButton';
import BooksLabeledContainer from '../../../../components/books/model1/BooksLabeledContainer';
import BooksTextInput, {
  TextInputType,
} from '../../../../components/books/model1/forms/BooksTextInput';
import BooksCreateUserConfirmAlert from '../../../../components/books/model1/texts/BooksCreateUserConfirmAlert';
import { ErrorType } from '../../../../domain/entities/Auth';
import { CreateUserQuery } from '../../../../infrastructure/repositories/AuthRepository';
import * as $ from './helper';
import ErrorMessage from './InputCreateUserErrorMessage';

interface Props {
  postable: boolean;
  onSubmit: (query: CreateUserQuery) => void;
  errors?: ErrorType[];
}

interface Control {
  submittable?: boolean;
}

interface State {
  lastName: string;
  firstName: string;
  email: string;
  password: string;
  control: Control;
}

class InputLogin extends React.Component<Props & InjectedIntlProps, State> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    const _state: State = {
      lastName: '',
      firstName: '',
      email: '',
      password: '',
      control: {},
    };
    this.state = {
      ..._state,
      control: this.createControl(_state),
    };
  }

  private createControl(state: State): Control {
    const { control } = state;
    control.submittable =
      $.getValueByNestedString(state, 'lastName') &&
      $.getValueByNestedString(state, 'firstName') &&
      $.getValueByNestedString(state, 'email') &&
      $.getValueByNestedString(state, 'password');
    return control;
  }

  private handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const {
      currentTarget: { name, value },
    } = e;
    const changedState = $.changeObjectByNestedString(this.state, name, value);
    this.setState({
      ...changedState,
      control: this.createControl(changedState as State),
    });
  }

  private async handleSubmit() {
    const { lastName, firstName, email, password } = this.state;
    this.props.onSubmit({ lastName, firstName, email, password });
  }

  public render() {
    const { postable, intl, errors } = this.props;
    const {
      control: { submittable },
    } = this.state;

    return (
      <div>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.lastName',
          })}
          paddingTop={true}
        >
          <BooksTextInput
            type={TextInputType.Text}
            name={'lastName'}
            value={this.state.lastName}
            onChange={this.handleChange}
          />
        </BooksLabeledContainer>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.firstName',
          })}
          paddingTop={true}
        >
          <BooksTextInput
            type={TextInputType.Text}
            name={'firstName'}
            value={this.state.firstName}
            onChange={this.handleChange}
          />
        </BooksLabeledContainer>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.email',
          })}
          paddingTop={true}
        >
          <BooksTextInput
            type={TextInputType.Email}
            name={'email'}
            value={this.state.email}
            onChange={this.handleChange}
          />
        </BooksLabeledContainer>
        <BooksLabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.password',
          })}
        >
          <BooksTextInput
            type={TextInputType.Password}
            name={'password'}
            value={this.state.password}
            onChange={this.handleChange}
            placeholder={intl.formatMessage({
              id: 'books.formsLabel.passwordPlaceholder',
            })}
          />
        </BooksLabeledContainer>
        <ErrorMessage errors={errors} />
        <BooksCreateUserConfirmAlert />
        <BooksSubmitButton
          type="button"
          onClick={this.handleSubmit}
          value={intl.formatMessage({ id: 'books.submitLabel.userResist' })}
          disabled={!submittable || !postable}
          postable={postable}
        >
          {intl.formatMessage({ id: 'books.submitLabel.userResist' })}
        </BooksSubmitButton>
      </div>
    );
  }
}

export default injectIntl(InputLogin);
